// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dv2Z1__layout {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 100vh;
  background: var(--color-paper-2);
  z-index: 1000;
  overflow-y: auto;
  padding-bottom: 6em;
}

.Dv2Z1__layout a {
    color: var(--color-blue-1);
    -webkit-text-decoration: underline;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

.Dv2Z1__layout a:hover {
      opacity: 0.8;
    }

.zv61p__pageHeader {
  display: flex;
  align-items: center;
  gap: 0.8em;
  padding: 1.5em 1.5em 0;
  max-width: 1240px;
  margin: 0 auto;
}

.zv61p__pageHeader a {
    font-size: 1.5em;
    color: var(--color-blue-1);
  }

.zv61p__pageHeader h1 {
    margin: 0;
  }

/* Hero */
.PkXb5__hero {
  text-align: center;
  padding: 5em 1.5em 4em;
  max-width: 640px;
  margin: 0 auto;
}
.PkXb5__hero h2 {
    font-size: 3.5em;
    margin: 0 0 0.3em;
    line-height: 1.1;
  }

.sl5zi__heroPre {
  font-size: 1.5em;
  opacity: 0.85;
}

.sl5zi__heroPre strong {
    font-weight: bold;
  }

.rhW5F__heroSub {
  font-size: 1.15em;
  opacity: 0.7;
  font-weight: bold;
  text-transform: uppercase;
  margin-top: 3em;
}

.wIocD__bios {
  display: flex;
  flex-direction: column;
  gap: 1.5em;
  padding: 1em 1.5em 2em;
  max-width: 1240px;
  margin: 0 auto;
  align-items: stretch;
}

.wIocD__bios .h4z5u__profilePhoto {
    width: 100%;
    min-height: 300px;
    height: 30vh;
    object-fit: cover;
  }

.wIocD__bios .OtYWl__bioCard a {
    white-space: nowrap;
  }

@media (min-width: 768px) {

.wIocD__bios {
    flex-direction: row;
    align-items: flex-start;
}

    .wIocD__bios .OtYWl__bioCard {
      flex: 1;
      flex-shrink: 0;
    }

    .wIocD__bios .h4z5u__profilePhoto {
      min-height: 400px;
    }
  }

/* CTA */
.YdLwA__cta {
  max-width: 640px;
  margin: 0 auto;
  padding: 2em 1.5em;
  text-align: center;
}
.YdLwA__cta h2 {
    font-size: 1.8em;
    margin: 0 0 0.5em;
  }
.YdLwA__cta strong {
    font-weight: bold;
  }

.CtvyV__getTheApp {
  font-size: 1.2em;
  margin-top: 1.5em;
  justify-content: center;
}

@media screen and (min-width: 1024px) {

.CtvyV__getTheApp {
    font-size: 1.3em;
}
  }

.UOKiM__ambassadorButton {
  margin-top: 1.5em;
  font-size: 1.2em;
  font-weight: bold;
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/routes/about/AboutRoute.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AAWrB;;AATE;IACE,0BAA0B;IAC1B,kCAA0B;IAA1B,0BAA0B;IAC1B,0BAA0B;EAK5B;;AAHE;MACE,YAAY;IACd;;AAIJ;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAUhB;;AARE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;AAEA;IACE,SAAS;EACX;;AAGF,SAAS;AACT;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAOhB;AALE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,gBAAgB;EAChB,aAAa;AAKf;;AAHE;IACE,iBAAiB;EACnB;;AAGF;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AA0BtB;;AAxBE;IACE,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;EACnB;;AAEA;IACE,mBAAmB;EACrB;;AAEA;;AApBF;IAqBI,mBAAmB;IACnB,uBAAuB;AAW3B;;IATI;MACE,OAAO;MACP,cAAc;IAChB;;IAEA;MACE,iBAAiB;IACnB;EACF;;AAGF,QAAQ;AACR;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AAUpB;AARE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AAEA;IACE,iBAAiB;EACnB;;AAGF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AAKzB;;AAHE;;AALF;IAMI,gBAAgB;AAEpB;EADE;;AAGF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,wCAAgC;EAAhC,gCAAgC;AAClC","sourcesContent":[".layout {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 100vh;\n  background: var(--color-paper-2);\n  z-index: 1000;\n  overflow-y: auto;\n  padding-bottom: 6em;\n\n  & a {\n    color: var(--color-blue-1);\n    text-decoration: underline;\n    text-underline-offset: 2px;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n}\n\n.pageHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.8em;\n  padding: 1.5em 1.5em 0;\n  max-width: 1240px;\n  margin: 0 auto;\n\n  & a {\n    font-size: 1.5em;\n    color: var(--color-blue-1);\n  }\n\n  & h1 {\n    margin: 0;\n  }\n}\n\n/* Hero */\n.hero {\n  text-align: center;\n  padding: 5em 1.5em 4em;\n  max-width: 640px;\n  margin: 0 auto;\n\n  & h2 {\n    font-size: 3.5em;\n    margin: 0 0 0.3em;\n    line-height: 1.1;\n  }\n}\n\n.heroPre {\n  font-size: 1.5em;\n  opacity: 0.85;\n\n  & strong {\n    font-weight: bold;\n  }\n}\n\n.heroSub {\n  font-size: 1.15em;\n  opacity: 0.7;\n  font-weight: bold;\n  text-transform: uppercase;\n  margin-top: 3em;\n}\n\n.bios {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5em;\n  padding: 1em 1.5em 2em;\n  max-width: 1240px;\n  margin: 0 auto;\n  align-items: stretch;\n\n  & .profilePhoto {\n    width: 100%;\n    min-height: 300px;\n    height: 30vh;\n    object-fit: cover;\n  }\n\n  & .bioCard a {\n    white-space: nowrap;\n  }\n\n  @media (min-width: 768px) {\n    flex-direction: row;\n    align-items: flex-start;\n\n    & .bioCard {\n      flex: 1;\n      flex-shrink: 0;\n    }\n\n    & .profilePhoto {\n      min-height: 400px;\n    }\n  }\n}\n\n/* CTA */\n.cta {\n  max-width: 640px;\n  margin: 0 auto;\n  padding: 2em 1.5em;\n  text-align: center;\n\n  & h2 {\n    font-size: 1.8em;\n    margin: 0 0 0.5em;\n  }\n\n  & strong {\n    font-weight: bold;\n  }\n}\n\n.getTheApp {\n  font-size: 1.2em;\n  margin-top: 1.5em;\n  justify-content: center;\n\n  @media (--screen-lg) {\n    font-size: 1.3em;\n  }\n}\n\n.ambassadorButton {\n  margin-top: 1.5em;\n  font-size: 1.2em;\n  font-weight: bold;\n  text-decoration: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export var layout = `Dv2Z1__layout`;
export var pageHeader = `zv61p__pageHeader`;
export var hero = `PkXb5__hero`;
export var heroPre = `sl5zi__heroPre`;
export var heroSub = `rhW5F__heroSub`;
export var bios = `wIocD__bios`;
export var profilePhoto = `h4z5u__profilePhoto`;
export var bioCard = `OtYWl__bioCard`;
export var cta = `YdLwA__cta`;
export var getTheApp = `CtvyV__getTheApp`;
export var ambassadorButton = `UOKiM__ambassadorButton`;
export default ___CSS_LOADER_EXPORT___;
